<template>
  <div class="app-nav">
    <ul class="app-nav-list" v-show="!smallScreen">
      <router-link to='/' tag="li"><a class="app-router-link" tabindex="0">Compare Quarters</a></router-link>
      <router-link to='/historical-view' tag="li"><a class="app-router-link" tabindex="0" >Historical View</a></router-link>
    </ul>
  </div>               
</template>

<script>
export default {
  name: 'app-nav',
  props: ['smallScreen'],
};
</script>

<style lang="less">
  .app-nav {
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 20px;
  }
  .app-nav-list {
    list-style: none;
    padding-left: 5px;
    height: 30px;
    margin-bottom: 0; 
    li {
      cursor: pointer;
      float: left;
      width: 200px;
      height: 100%;
      font-size: 16px;
      margin-right: 3px;
      margin-bottom: 0;
      border-top: 1px solid #d3d3d3;
      border-left: 1px solid #d3d3d3;
      border-right: 1px solid #d3d3d3;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      background-color: rgb(230, 230, 230);

      a {
        color: inherit;
        text-decoration: none;
        display: inline-block;
        width: 100%;
        height: 100%;
        padding-left: 20px;
        padding-top: 5px;
      }
      &:hover {
        background-color: #dadada;
        border-top: 1px solid #999;
        border-left: 1px solid #999;
        border-right: 1px solid #999;
      }
      @media (max-width: 700px) {
        width: 49%;
        padding-left: 10px;
      }
    }
    li.router-link-exact-active {
      border-top: 1px solid #aaa;
      border-left: 1px solid #aaa;
      border-right: 1px solid #aaa;
      background-color: #fff;
      height: 32px;
      border-bottom: 2px solid #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// AppNav.vue?735c1720